import "regenerator-runtime/runtime";
const api = {
  extractTextFromPDF: async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

    let allText = "";
    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
      const page = await pdf.getPage(pageNumber);
      const textContent = await page.getTextContent();
      const pageText = textContent.items.map(item => item.str).join(" ");
      allText += pageText + "\n\n";
    }
    return allText.trim();
  },
  sendToServerless: async (jobDescription, resumeText) => {
    const requestBody = { jobDescription, resumeText };
    console.log("Sending POST request to /checkAddress with:", requestBody);

    const response = await fetch("/.netlify/functions/checkAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Response from serverless (Gemini result):", data);
    return data;
  }
};

document.getElementById("gemini-submit").addEventListener("click", async () => {
  const pdfFile = document.getElementById("pdf-input").files[0];
  const jobDescription = document.getElementById("job-description-input").value.trim();

  if (!pdfFile) {
    alert("Please select a PDF resume file.");
    return;
  }

  if (!jobDescription) {
    alert("Please paste the job description.");
    return;
  }

  try {
    console.log("Job Description:", jobDescription);
    console.log("Extracting text from PDF...");
    const extractedText = await api.extractTextFromPDF(pdfFile);
    console.log("Extracted Resume Text:", extractedText);

    const result = await api.sendToServerless(jobDescription, extractedText);
    document.getElementById("gemini-output").textContent = JSON.stringify(result, null, 2);
  } catch (error) {
    console.error("Error:", error);
    document.getElementById("gemini-output").textContent = "An error occurred.";
  }
});
